export default function Total({title, price, type}) {
    return (
        <div className="total">
            <h3 className="total__title">{title}</h3>
            <p className="total__price">{price} {type ? type : "€"}</p>
        </div>
    )
}